{
  "google-maps-embed-iframe-dialog": {
    "buttons": {
      "close": "Đóng"
    }
  }
}
